// extracted by mini-css-extract-plugin
export default {"rateCandidate":"RateCandidate_rateCandidate__4k-EG","yellowStarIcon":"RateCandidate_yellowStarIcon__fd27e","grayStarIcon":"RateCandidate_grayStarIcon__osuK7"};